import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";

import { useHistory } from "react-router-dom";
import { AvForm, AvField } from "availity-reactstrap-validation";
import {
  Row,
  Col,
  FormGroup,
  Label,
  Alert,
  Card,
  CardBody,
  CardTitle,
  Table,
  Button,
} from "reactstrap";
import profileIcon from "../../../assets/images/profile-icon.png";
import { getOnboarder, postOnboarder } from "../../../api/common";
import { handleErrorsAllMessage } from "../../../utils";
import { showLoader, removeLoader } from "../../../store/Loader/actions";
import CompleteButton from "../../CompleteButton";
import {
  setNextStep,
  nextState,
  previousState,
  saveActiveCompany,
} from "../../../store/CompanyState/actions";
import Categories from "./Categories.js";
import ExitButton from "../../ExitButton";
import ActionFooter from "../ActionFooter";
import ActionHeader from "../ActionHeader";
import debounce from "lodash.debounce";

const AccountingCategories = ({
  setNextStep,
  nextState,
  previousState,
  saveActiveCompany,
  company,
  showLoader,
  removeLoader,
}) => {
  let history = useHistory();
  const [canSave, setCanSave] = useState(false);
  const [errors, setErrors] = useState([]);
  const forms = useRef([]);
  const [revenueLines, setRevenueLines] = useState([]);
  const [deletedRevenue, setDeletedRevenue] = useState([]);
  const [costLines, setCostLines] = useState([]);
  const [deletedCost, setDeletedCost] = useState([]);
  const onValidSubmit = (e, vals) => {};
  let save = debounce(() => {
    saveAccountingCategories(() => {
      setNextStep(null);
      saveActiveCompany();
    });
  }, 200);
  const saveExit = debounce(() => {
    saveAccountingCategories(() => {
      setNextStep("exit");
      history.goBack();
    });
  }, 200);
  const next = debounce(() => {
    saveAccountingCategories(() => {
      setNextStep("next");
      nextState();
    });
  }, 200);
  const back = debounce(() => {
    saveAccountingCategories(() => {
      setNextStep("back");
      previousState();
    });
  }, 200);
  let saveAccountingCategories = (cb) => {
    let bodyRevenue = {
      categories: revenueLines.filter((line) => line.updated),
      delete: deletedRevenue,
    };
    let bodyCost = {
      categories: costLines.filter((line) => line.updated),
      delete: deletedCost,
    };
    if (
      bodyRevenue.categories.length ||
      bodyRevenue.delete.length ||
      bodyCost.categories.length ||
      bodyCost.delete.length
    ) {
      setCanSave(false);
      showLoader();
      postOnboarder(
        `/UserManagement/${company?.id}/revenue/submit`,
        bodyRevenue
      )
        .then((data) => {
          setErrors({});
          data.forEach((line) => {
            line.updated = false;
          });
          setRevenueLines(data);
          postOnboarder(`/UserManagement/${company?.id}/cost/submit`, bodyCost)
            .then((data) => {
              setErrors({});
              data.forEach((line) => {
                line.updated = false;
              });
              setCostLines(data);
              cb();
              setCanSave(true);
              removeLoader();
            })
            .catch((error) => {
              removeLoader();
              setErrors(error);
              setCanSave(true);
              throw error;
            });
        })
        .catch((error) => {
          removeLoader();
          setErrors(error);
          setCanSave(true);
          throw error;
        });
    } else {
      setErrors({});
      cb();
    }
  };

  const deleteRows = debounce(() => {
    setRevenueLines((lines) => lines.filter((line) => !line.selected));
    setDeletedRevenue(
      revenueLines.filter((line) => line.selected).map((line) => line.id)
    );
    setCostLines((lines) => lines.filter((line) => !line.selected));
    setDeletedCost(
      costLines.filter((line) => line.selected).map((line) => line.id)
    );
  }, 200);

  useEffect(() => {
    const div = document.querySelector(".alert-danger");
    div?.scrollIntoView({ behavior: "auto", block: "center" });
  }, [errors]);
  return (
    <div className="container-fluid">
      <ActionHeader
        canSave={canSave}
        save={save}
        deleteRows={deleteRows}
        lines={[
          ...revenueLines.filter((line) => line.is_deletable),
          ...costLines.filter((line) => line.is_deletable),
        ]}
        saveExit={saveExit}
      />
      <div className="">
        <Row>
          <Col>
            {handleErrorsAllMessage(errors) && (
              <Alert color="danger">{handleErrorsAllMessage(errors)}</Alert>
            )}
          </Col>
        </Row>

        <Row>
          <Col md="6">
            <Card className="">
              <CardBody>
                <CardTitle>Revenue Categories</CardTitle>
                <AvForm
                  className="needs-validation"
                  ref={(ref) => {
                    forms.current[0] = ref;
                  }}
                  onValidSubmit={onValidSubmit}
                >
                  <Categories
                    key="revenue"
                    type="revenue"
                    lines={revenueLines}
                    deleted={deletedRevenue}
                    setLines={setRevenueLines}
                    setDeleted={setDeletedRevenue}
                    setCanSave={setCanSave}
                    form={forms.current[0]}
                  />
                </AvForm>
              </CardBody>
            </Card>
          </Col>

          <Col md="6">
            <Card className="">
              <CardBody>
                <CardTitle>Cost of Revenue Categories</CardTitle>
                <AvForm
                  className="needs-validation"
                  ref={(ref) => {
                    forms.current[1] = ref;
                  }}
                  onValidSubmit={onValidSubmit}
                >
                  <Categories
                    key="cost"
                    type="cost"
                    lines={costLines}
                    deleted={deletedCost}
                    setLines={setCostLines}
                    setDeleted={setDeletedCost}
                    setCanSave={setCanSave}
                    form={forms.current[0]}
                  />
                </AvForm>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
      <ActionFooter
        next={next}
        canSave={canSave}
        back={back}
        complete={saveAccountingCategories}
      />
    </div>
  );
};
const mapStateToProps = (state) => {
  return { company: state.CompanyState.activeCompany };
};
export default connect(mapStateToProps, {
  setNextStep,
  nextState,
  previousState,
  saveActiveCompany,
  showLoader,
  removeLoader,
})(AccountingCategories);
